/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GA4_EVENT_SIGN_UP, PAGE_DATA_LAYER, SIGN_UP } from '@/data/constants/gtm';
import { getGTMSignUpEventData } from '@/data/events/data/gtm/SignUp';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMSignUpPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (data: Awaited<ReturnType<typeof getGTMSignUpEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: GA4_EVENT_SIGN_UP,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const measure_UA = async (data: Awaited<ReturnType<typeof getGTMSignUpEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	const tagManagerArgs = {
		dataLayer: {
			event: SIGN_UP,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const sendGTMSignUpEvent = async (payload: GTMSignUpPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = await getGTMSignUpEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(undefined, 'SignUp: sendGTMSignUpEvent: measure_UA: error: %o', error);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(undefined, 'SignUp: sendGTMSignUpEvent: measure_GA4: error: %o', error);
			}
		}
	}
};
